"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ActionTypes_1 = require("../ActionTypes");
var initialState = {
    screenshots: 0,
    environments: {
        available: [],
        current: ""
    },
    thumbs: {},
    allcodes: null,
    changingMode: null
};
function default_1(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case ActionTypes_1.SET_SCREENSHOT_COUNT: {
            return __assign(__assign({}, state), { screenshots: action.data });
        }
        case ActionTypes_1.ADD_SCREENSHOT: {
            return __assign(__assign({}, state), { screenshots: state.screenshots + (action.data || 1) });
        }
        case ActionTypes_1.DELETE_SCREENSHOT: {
            return __assign(__assign({}, state), { screenshots: state.screenshots - (action.data || 1) });
        }
        case ActionTypes_1.RESTORE_SCREENSHOT: {
            return __assign(__assign({}, state), { screenshots: state.screenshots + (action.data || 1) });
        }
        case ActionTypes_1.UPDATE_ENVIRONMENT: {
            return __assign(__assign({}, state), { environments: __assign(__assign({}, state.environments), { current: action.data }) });
        }
        case ActionTypes_1.UPDATE_ENVIRONMENTS: {
            return __assign(__assign({}, state), { environments: __assign(__assign({}, state.environments), { available: action.data.environments }) });
        }
        case ActionTypes_1.UPDATE_THUMBS: {
            return __assign(__assign({}, state), { thumbs: action.data });
        }
        case ActionTypes_1.SET_ALL_CODES: {
            return __assign(__assign({}, state), { allcodes: action.data });
        }
        case ActionTypes_1.UPDATE_MODE: {
            return __assign(__assign({}, state), { changingMode: action.data.pending ? action.data.target : null });
        }
        default: {
            return state;
        }
    }
}
exports.default = default_1;
//# sourceMappingURL=UI.js.map